import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { dAppConnectorInstance } from "../../constants/cardano";
import { useWallet, useWalletApi, useWalletDetails, useWalletOptions, } from "../../hooks";
import { Actions, EStrategy, useWalletContext } from "../../store";
const handleShutdown = () => {
    dAppConnectorInstance.ref?.instance().shutdownServer();
};
const Bootstrap = ({ children }) => {
    const queryClient = useQueryClient();
    const { dispatch } = useWalletContext();
    const { options } = useWalletOptions();
    const { details, activeWallet } = useWalletDetails();
    const { logoutWallet: onDisconnect } = useWallet();
    const { connectApi } = useWalletApi();
    useEffect(() => {
        if (options.strategy === EStrategy.CIP30) {
            // Destroy any lingering CIP-45 instance.
            if (dAppConnectorInstance.ref || activeWallet?.includes("p2p")) {
                onDisconnect().then(() => {
                    dAppConnectorInstance.ref = undefined;
                });
            }
            // Auto-connect API if not initialized.
            if (activeWallet && !activeWallet?.includes("p2p")) {
                connectApi({ overrideWallet: false });
            }
        }
        else {
            if (details) {
                Actions.setActiveWallet(null, dispatch);
                Actions.setWalletDetails(null, dispatch);
            }
            (async () => {
                await import("@sundae/wallets").then(async ({ getCip45Connection }) => {
                    dAppConnectorInstance.ref = await getCip45Connection({
                        dAppInfo: {
                            name: options.dAppName || "Wallet React dApp, by SundaeSwap",
                            url: window.location.origin,
                        },
                        onDisconnect,
                        async onApiInject(name, _address) {
                            const api = await connectApi({ overrideWallet: name });
                            if (api) {
                                Actions.setActiveWallet(name, dispatch);
                            }
                            else {
                                Actions.logout(dispatch);
                            }
                        },
                        verifyConnection(walletInfo, callback) {
                            queryClient.cancelQueries();
                            return callback(true, walletInfo.requestAutoconnect);
                        },
                        useWalletDiscovery: true,
                        announce: [
                            "wss://tracker.de-0.eternl.art",
                            "wss://tracker.us-0.eternl.art",
                        ],
                    });
                    Actions.setDappConnector(dAppConnectorInstance.ref, dispatch);
                });
            })();
        }
        window.addEventListener("beforeunload", handleShutdown, { capture: true });
        return () => {
            window.removeEventListener("beforeunload", handleShutdown, {
                capture: true,
            });
        };
    }, [options.strategy]);
    return _jsx(_Fragment, { children: children });
};
export default Bootstrap;
//# sourceMappingURL=Bootstrap.js.map